<template>
    <Sheet>  <h2>{{routeTitle}}</h2>


        <el-form
                :model="model"
                :rules="rules"
                label-width="120px"
                ref="form"
        >
            <el-form-item
                    label="姓名"
                    prop="name"
            >
                <el-input
                        placeholder="請輸入姓名"
                        v-model="model.name"
                ></el-input>
            </el-form-item>
            <el-form-item
                    label="電子郵件"
                    prop="email"
            >
                <el-input
                        placeholder="請輸入email"
                        v-model="model.email"
                ></el-input>
            </el-form-item>
            <el-form-item
                    label="行動電話"
                    prop="mobile"

            >
                <el-input
                        placeholder="請輸入行動電話"
                        v-model="model.mobile"
                ></el-input>
            </el-form-item>
            <el-form-item
                    label="生理性別"
                    prop="gender"
            >
                <el-select v-model="model.gender">
                    <el-option
                            :label="g.label"
                            :value="g.value"
                            v-for="g in genders"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                    label="生日"
                    prop="birthdate"
            >
                <el-date-picker
                        placeholder="請選擇生日"
                        type="date"
                        v-model="model.birthdate"
                        format="yyyy-MM-dd"
                ></el-date-picker>
            </el-form-item>
            <el-form-item
                    label="教育程度"
                    prop="education"
            >
                <el-radio-group v-model="model.education">
                    <el-radio
                            :label="e.value"
                            v-for="e in educations"
                    >
                        {{e.label}}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                    label="來源"
                    prop="sources"
            >
                <el-checkbox-group v-model="model.sources">
                    <el-checkbox
                            :label="e.value"
                            v-for="e in sources"
                    >
                        {{e.label}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="附件" v-if="fileLimit">
            <el-upload
                    :action="action"
                    :before-remove="handleBeforeRemove"
                    :before-upload="beforeUpload"
                    :data="dataOptions"
                    :headers="uploadHeaders"
                    :limit="4"
                    :on-error="onUploadError"
                    :on-exceed="onExceedLimit"
                    :on-success="onUploadSuccess"
                    ref="upload"

            >
                <el-button>選擇檔案</el-button>
                <template #tip>
                    <div class="el-upload__tip">
                        檔案不超過5MB
                    </div>
                </template>
            </el-upload>
        </el-form-item>
            <el-button
                    @click="submit"
            >
                送出
            </el-button>
        </el-form>
    </Sheet>
</template>

<script>import {mapActions} from 'vuex';
    import moment from 'moment';
    import routeTitleMixin from './routeTitleMixin';
    import UploadMixin from '../uploadMixin';

    const defaultModel = {
        name: '',
        email: '',
        mobile: '',
        gender: null,
        education: null,
        sources: [],
        birthdate: null,
        uploads: [],
    };
    export default {
        name: 'Form',
        data: () => ({
            model: {...defaultModel},
            rules: {
                name: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'}
                ],
                email: [
                    {required: true, message: '請輸入姓名', trigger: 'blur'},
                    {type: 'email', message: '請輸入合格的信箱', trigger: ['blur', 'change']}
                ],
                mobile: [
                    {required: true, message: '請輸入電話', trigger: 'blur'}
                ],
                gender: [
                    {required: true, message: '請選擇生理性別'}
                ],
                birthdate: [
                    {required: true, message: '請輸入生日'}
                ],
                education: [
                    {required: true, message: '請選擇教育程度'}
                ]
            },
            url: 'upload',
        }),

        computed: {
            genders() {
                return [
                    {label: '男', value: 1},
                    {label: '女', value: 2},
                ];
            },
            educations() {
                return [
                    {label: '國小', value: 1,},
                    {label: '國中', value: 2,},
                    {label: '高中', value: 3,},
                    {label: '大學', value: 4,},
                ]
            },
            sources() {
                return [
                    {label: '新聞', value: 1,},
                    {label: '雜誌', value: 2,},
                    {label: '電視', value: 3,},
                ]
            }
        },

        mixins: [routeTitleMixin, UploadMixin],

        methods: {
            ...mapActions('form', {
                insert: 'insertFormAction'
            }),

            submit() {
                const current = this.$refs['form'];
                current.validate(async valid => {
                    if (valid) {
                        const sources = (this.model.sources || '').join(',');
                        const {success} = await this.insert({
                            ...this.model,
                            sources,
                            birthdate: moment(this.model.birthdate).format('YYYY-MM-DD')
                        });
                        if (success) {
                            this.$message({
                                type: 'success',
                                message: '表單送出成功'
                            });
                            this.$router.push('/table')
                        } else {
                            this.$message({
                                type: 'danger',
                                message: '表單送出失敗，請重試一次'
                            });
                        }
                        this.reset();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '驗證失敗，請檢查*欄位'
                        });
                    }
                })
            },

            reset() {
                const vm = this;
                this.$refs['form'].resetFields();
                this.$nextTick(() => vm.$refs['form'].clearValidate());
                this.model = {...defaultModel};
                this.$refs['upload'].clearFiles();
            },


            onUploadSuccess(res) {
                this.model.uploads.push(res);
            },

            async handleBeforeRemove(file) {
                await this.beforeRemove(file);
                this.model.uploads = this.model.uploads.filter(f => f.uid !== file.uid);
            },


        }
    }</script>

<style scoped>

</style>